module.exports = __webpack_public_path__ + "static/img/sz.0e7e4b3c.png";